/**
 * This file is created manually
 * You can change the content
 *
 */

import Paragraph from './typography/Paragraph'
export * from './typography/Paragraph'
export default Paragraph
